import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import SiteLayout from "@/components/SiteLayout";
import HomePage from "@/pages/HomePage";
import PhoneCaseDesigner from "@/components/PhoneCaseDesigner";
import PhoneCaseVendingPage from "@/pages/PhoneCaseVendingPage";
import FoodDrinkVendingPage from "@/pages/FoodDrinkVendingPage";
import HostAMachinePage from "@/pages/HostAMachinePage";
import ScrollToTop from "@/components/ScrollToTop";
import GoogleAnalytics from "@/components/GoogleAnalytics";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <GoogleAnalytics />
                <Routes>
                    <Route element={<SiteLayout />}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/designer" element={<PhoneCaseDesigner />} />
                        <Route path="/phone-case-vending" element={<PhoneCaseVendingPage />} />
                        <Route path="/food-drink-vending" element={<FoodDrinkVendingPage />} />
                        <Route path="/host-a-machine" element={<HostAMachinePage />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Route>
                </Routes>
            </BrowserRouter>
            <Toaster position="top-center" richColors />
        </div>
    );
}

export default App;
